
const links = {
    home: '/',
    events: '/events',
    courses: '/courses',
    elearning: '/e-learning',
    conferences: '/conferences',
    contact: 'http://www.rheglobal.com/contact'
};

const isLinkActive = link => {
    return window.location.pathname === link;
};

export const generatePlatformLinks = () => {
    return [
        {
            label: 'Home',
            show: true,
            url: links.home,
            isActive: isLinkActive(links.home)
        },
        {
            label: 'Programme',
            show: true,
            url: links.events,
            isActive: isLinkActive(links.events)
        },
        {
            label: 'Courses',
            show: true,
            url: links.courses,
            isActive: isLinkActive(links.courses)
        },
        {
            label: 'e-Learning',
            show: true,
            url: links.elearning,
            isActive: isLinkActive(links.elearning)
        },
        {
            label: 'Conferences',
            show: true,
            url: links.conferences,
            isActive: isLinkActive(links.conferences)
        },
        {
            label: 'Contact',
            show: true,
            url: links.contact,
            isActive: false
        }
    ];
};


// WEBPACK FOOTER //
// ./services/navigationLinkGenerator.js